'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$75() {
  this.bHl = null;
  this.bHm = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$75 as $c_Lpresto_TwoFactorAuthView$$anon$75 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$75.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$75;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$75() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$75 as $h_Lpresto_TwoFactorAuthView$$anon$75 };
$h_Lpresto_TwoFactorAuthView$$anon$75.prototype = $p;
$p.P = (function() {
  if ((!this.bHm)) {
    this.bHl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T3($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bHm = true;
  }
  return this.bHl;
});
var $d_Lpresto_TwoFactorAuthView$$anon$75 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$75, "presto.TwoFactorAuthView$$anon$75", ({
  Tg: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$75 as $d_Lpresto_TwoFactorAuthView$$anon$75 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$75.js.map
